
import { UpdateStandardReturnStateParameter } from "@dana/Services/DanaStandardReturnOrderService";
import { DanaStandardReturnOrderActions } from "@dana/Store/Data/StandardReturns/Reducers/GetStandardReturnOrderReducer";
import { ApiHandler, createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";


type HandlerType = Handler<UpdateStandardReturnStateParameter,
    DispatchProp<DanaStandardReturnOrderActions>
>;

export const DispatchSetParameters: HandlerType = props => {
    props.dispatch({
        type: "StandardReturn/UpdateSelectedLines",
        selectedLines: props.parameter.selectedLines,
    } as any);
};
export const chain = [DispatchSetParameters];

const updateSelectedLines = createHandlerChainRunner(chain, "UpdateSelectedLinesHandler");
export default updateSelectedLines;